/** Firestore collection names — keep in sync with saz_soz `FirebaseService`. */
export const FIRESTORE_COLLECTIONS = {
  users: "users",
  webSessions: "webSessions",
  favorites: "favorites",
  repertoires: "repertoires",
  songRequests: "song_requests",
  sponsors: "sponsors",
} as const;
